import { useQuarantineStore } from '@Quarantine/store';
import { useMemo } from 'react';

export const useDetectionTableQueryKey = (props: {
  sortOrder: 'desc' | 'asc';
}) => {
  const { sortOrder } = props;
  const currentOrgId = useQuarantineStore((state) => state.currentOrgId);
  const currentUtcOffset = useQuarantineStore(
    (state) => state.currentUtcOffset
  );
  const riskTypeFilterValue = useQuarantineStore(
    (state) => state.riskAi.filters.riskTypeFilter.currentValue
  );
  const timeFilterValue = useQuarantineStore(
    (state) => state.riskAi.filters.timeFilter.currentValue
  );
  const timeFilterCustom = useQuarantineStore(
    (state) => state.riskAi.filters.timeFilter.custom
  );
  const serviceFilterValue = useQuarantineStore(
    (state) => state.riskAi.filters.serviceFilter.currentValue
  );
  const tagFilterValue = useQuarantineStore(
    (state) => state.riskAi.filters.tagFilter.currentValue.id
  );
  const securityRiskNameFilterValue = useQuarantineStore(
    (state) => state.riskAi.filters.securityRiskNameFilter.currentValue
  );
  const anomalyNameFilterValue = useQuarantineStore(
    (state) => state.riskAi.filters.anomalyNameFilter.currentValue
  );
  const detectedByFilterValue = useQuarantineStore(
    (state) => state.riskAi.filters.detectedByFilter.currentValue
  );

  const queryKey = useMemo(
    () => [
      currentOrgId,
      currentUtcOffset,
      riskTypeFilterValue,
      timeFilterCustom ?? timeFilterValue,
      serviceFilterValue,
      tagFilterValue,
      securityRiskNameFilterValue,
      anomalyNameFilterValue,
      detectedByFilterValue,
      sortOrder,
    ],
    [
      currentOrgId,
      currentUtcOffset,
      riskTypeFilterValue,
      timeFilterCustom,
      timeFilterValue,
      serviceFilterValue,
      tagFilterValue,
      securityRiskNameFilterValue,
      anomalyNameFilterValue,
      detectedByFilterValue,
      sortOrder,
    ]
  );

  return queryKey;
};
